export const PublicType = {
    class: {
        Flowchart: "1261",
        "Basic Flowchart": "1261",
        "Cross Functional Flowchart": "1043",
        "Mind Map": "1256",
        mindmap: "1256",
        "Org Chart(Automated)": "1067",
        "Org Chart(Manual)": "1263",
        "Graphs and Charts": "1270",
        "Gantt Charts": "1089",
        "Floor Plan1": "1266",
        "Floor Plan2": "1148",
        "Fire and Emergency Plan": "1155",
        "Network Diagram": "1126",
        "Organizational Chart": "1263",
        Timelines: "1034",
        "Basic Diagram": "1041",
        "Electrical Engineering": "1137",
        "Software Development": "1265",
        "Project Management": "1264",
        "Quality Management": "1054",
        "Strategy and Planning": "1233",
        Marketing: "1262",
        "Analysis Canvas": "1230",
        "Database Modeling": "1112",
        Map: "1190",
        Science: "1180",
        "Graphic Organizer": "1268",
        "Graphic Design": "1154",
        Infographic: "1080",
        Card: "1269",
        "UI&UX": "1267",
    } as Record<string, string>,
};
